// extracted by mini-css-extract-plugin
export default {"DiscountCode":"styles_DiscountCode__U9j0B","title":"styles_title__88DCT","row":"styles_row__f5z9B","code":"styles_code__a0yLt","copyButton":"styles_copyButton__e33gx"};